module.exports = __webpack_public_path__ + "static/img/paprykwr.70d2244b.webp";